import produce from 'immer';
import { storageService } from '../../services/storage/storage';
import { initialRootState } from '../initialRootState';
import { EAuthActionType, TAuthAction } from './actions';
import { IToken } from './types';

export interface IAuthState {
  token?: Omit<IToken, 'enc'>;
}

export const authReducer = (
  state: IAuthState = initialRootState.auth,
  action: TAuthAction
): IAuthState =>
  produce(state, draft => {
    switch (action.type) {
      case EAuthActionType.LOGIN_SUCCESS:
        const { enc, ...restToken } = action.payload.token;

        storageService.persistRefreshToken(enc);
        draft.token = restToken;
        break;
    }
  });
